<template>
    <table class="w-full table-auto font-mono text-sm mt-4 text-left px-2 overflow-x-auto">
        <thead class="font-mono">
        <tr class="">
            <th class="px-2 py-3">Datum</th>
            <th class="px-2 py-3">Typ</th>
            <th class="px-2 py-3">Nachricht</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="event of events"
            :key="event.id"
            class="event:bg-gray-100 odd:bg-gray-300">
            <td class="px-2 py-3">{{event.created_at}}</td>
            <td class="px-2 py-3 uppercase">{{event.type}}</td>
            <td class="px-2 py-3">{{event.message}}</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import OrderTracking from "@/Pages/Sales/Order/Components/OrderTracking";
import OrderContact from "@/Pages/Sales/Order/Components/OrderContact";
import OrderTaxTable from "@/Pages/Sales/Order/Components/OrderTaxTable";
import OrderAddress from "@/Pages/Sales/Order/Components/OrderAddress";
import OrderHead from "@/Pages/Sales/Order/Components/OrderHead";
import OrderState from "@/Pages/Sales/Order/Components/OrderState";
import Detail from "@/Pages/Sales/Order/Detail";
import AppLayout from "@/Layouts/AppLayout";

export default {
    name: "Overview",
    props: ['order', 'critical', 'events'],
    layout: [AppLayout, Detail],
    components: {
        OrderTracking,
        OrderContact,
        OrderTaxTable,
        OrderAddress,
        OrderHead,
        OrderState,
    }
}
</script>

<style scoped>

</style>
